<template>
  <v-select
    :label="$t(label)"
    :items="items"
    :hide-details="shouldHideDetails"
    :value="data"
    @change="$emit('change', $event)"
  ></v-select>
</template>

<script>
import { findMatchI18n } from '@/utils/findMatchI18n'
export default {
  name: 'InsertionLevelInput',

  props: {
    data: {
      type: [String, Number],
      required: false,
    },

    data() {
        return {
            field: 'insertionLevel',
            label: 'report_preview.insertion_level'
        }
    },
  },

  computed: {
      items() {
          const locale = this.$i18n.locale
          // 翻譯當中的 label 欄位
          let _tmpOptions = this.$store.getters['examinations/getInsertionLevelList'].map((item) => {
              return {
                  value: item.value,
                  text: findMatchI18n(item.text)
              }
          })
          return _tmpOptions
      },
      shouldHideDetails() {
          return this.hideDetails
      }
  }
}
</script>
